import request from './request';

export const PARTITION_GET_LIST = 'amp2.RoleSrv/GetPartitionList';

export default class Partition {
  static async fetch(params) {
    const res = await request.post(PARTITION_GET_LIST, params);
    return res;
  }
}
// export default class Partition {
//   static async fetch(params) {
//     const data = await request.post(PARTITION_GET_LIST, params);
//     return data.list;
//   }
// }
